/**
 * The fixture fetch status element's test id. The capture harnesses cannot import
 * TypeScript, so `scripts/visual/preview/appContract.mjs` declares the same value,
 * and `previewServer.test.mjs` fails when the two differ.
 */
export const FIXTURE_LOADING_TESTID = 'fixture-loading';
